
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconArrowLeft from '@components/icons/icon-arrow-left.svg';
import PlusIcon from '@components/icons/icon-plus.svg';
import { RawLocation } from 'vue-router';

@Component({
  name: 'SettingsTitleBar',
  components: {
    IconArrowLeft,
    PlusIcon
  },
})
export default class SettingsTitleBar extends Vue {
  @Prop()
  private to: RawLocation;

  @Prop({ default: false })
  private add: boolean;
}
